import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { nlNL } from '@mui/x-date-pickers/locales'
import { useTranslation } from 'react-i18next'
import { BrowserRouter } from 'react-router'
import App from '../App'
import { SettingsProvider } from '../contexts/SettingsContext'
import AuthProvider from '../services/auth/provider'
import { useDateLocale } from '../utils/dateLocalization'

export function LocalizedApp() {
  const { i18n } = useTranslation()
  const locale = useDateLocale()

  const localeText =
    i18n.language === 'nl'
      ? nlNL.components.MuiLocalizationProvider.defaultProps.localeText
      : undefined

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={locale}
      localeText={localeText}
    >
      <SettingsProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </SettingsProvider>
    </LocalizationProvider>
  )
}
